import { render, staticRenderFns } from "./QuoteLogo.vue?vue&type=template&id=38cc3c98&"
import script from "./QuoteLogo.vue?vue&type=script&lang=js&"
export * from "./QuoteLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports